import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IOffersItem } from '../types';

interface OffersToCompareSlice {
  offers: IOffersItem[];
  addOffer: (offer: IOffersItem) => void;
  removeOffer: (offer: IOffersItem) => void;
  isOfferAdded: (offer: IOffersItem) => boolean;
}

const useOffersToCompareSlice = create<OffersToCompareSlice>()(
  persist(
    (set, get) => ({
      offers: [],
      addOffer: (offer) => set((state) => ({ offers: [...state.offers, offer] })),
      removeOffer: (offer) =>
        set((state) => ({ offers: [...state.offers.filter((item) => item.id !== offer.id)] })),
      isOfferAdded: (offer) => !!get().offers.find((item) => item.id === offer.id),
    }),
    {
      name: 'payblox-offers-to-compare',
    },
  ),
);

export default useOffersToCompareSlice;
